import { render } from "./QrCodeScreen.vue?vue&type=template&id=4915b96c&scoped=true&lang=html"
import script from "./QrCodeScreen.vue?vue&type=script&lang=js"
export * from "./QrCodeScreen.vue?vue&type=script&lang=js"

import "./QrCodeScreen.vue?vue&type=style&index=0&id=4915b96c&lang=scss&scoped=true"

import exportComponent from "/Users/peterdevos/Apps/clawmachine_topdesk/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4915b96c"]])

export default __exports__